module.exports = __webpack_public_path__ + "img/level1_mining_hands.00e12c8b.png";